/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import clsx from 'clsx'
import UiFormContainer from 'components/Forms/UiFormContainer'
import UiFormModalHeader from 'components/Forms/UiFormModalHeader'
import UiFormBody from 'components/Forms/UiFormBody'
import UiFormStickyFooter from 'components/Forms/UiFormStickyFooter'

interface UiFormModalShellProps {
    title: React.ReactNode
    subtitle?: React.ReactNode
    children: React.ReactNode | React.ReactNode[]
    className?: string
    bodyClassName?: string
    headerBottom?: React.ReactNode
    headerCenter?: React.ReactNode
    headerActions?: React.ReactNode
    footer?: React.ReactNode
    showHeader?: boolean
    showHeaderCompact?: boolean
}

const UiFormModalShell = (props: UiFormModalShellProps) => {
    return (
        <UiFormContainer
            className={clsx(
                'UiFormModalShell',
				props.className,
                'text-gray-900',
                'dark:text-white',
                'min-h-0',
            )}
        >
            {props.showHeader && (
                <UiFormModalHeader
                    title={props.title}
                    subtitle={props.subtitle}
                    bottom={props.headerBottom}
                    actions={props.headerActions}
                />
            )}
            {props.showHeaderCompact && (
                <div
                    className={clsx(
                        'UiFormModalShellCompactHeader sticky top-0 z-20 min-h-16 flex flex-wrap items-center px-6 py-2 transition-colors border-b border-gray-100 dark:border-white/5 gap-x-6 gap-y-2 bg-white/90 dark:bg-gray-950/90 backdrop-blur-md',
                    )}
                >
                    {props.headerBottom && (
                        <div className="flex min-w-0 max-w-full items-center overflow-x-auto shrink-0">
                            {props.headerBottom}
                        </div>
                    )}
                    {props.headerCenter && (
                        <div className="flex min-w-0 max-w-full flex-1 basis-full items-center overflow-x-auto">
                            <div className="shrink-0">
                                {props.headerCenter}
                            </div>
                        </div>
                    )}
                    {props.headerActions && (
                        <div className="ml-auto flex items-center h-full gap-2 pr-10">
                            {props.headerActions}
                        </div>
                    )}
                </div>
            )}
            <UiFormBody
                className={clsx(
                    props.bodyClassName ? props.bodyClassName : 'px-6 py-6'
                )}
            >
                {props.children}
            </UiFormBody>
            {props.footer && (
                <UiFormStickyFooter>{props.footer}</UiFormStickyFooter>
            )}
        </UiFormContainer>
    )
}

export default UiFormModalShell
